<template>
  <v-container>
    <v-stepper v-model="step">
      <v-stepper-header>
        <v-stepper-step :complete="step > 1" step="1"
          >1. 下書きID発行</v-stepper-step
        >
        <v-divider></v-divider>
        <v-stepper-step :complete="step > 2" step="2"
          >2. ファイルアップロード</v-stepper-step
        >
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <v-card>
            <v-select
              v-model="selectedOutputImageType"
              :items="outputImageTypes"
              item-text="text"
              item-value="value"
              label="出力画像形式"
            ></v-select>
            <v-text-field v-model="title" label="作品タイトル"></v-text-field>

            <v-btn color="primary" @click="draft()"> 下書きID発行 </v-btn>
          </v-card>
        </v-stepper-content>
        <v-stepper-content step="2">
          <v-card>
            <v-card-text> 下書きID : {{ draftId }} </v-card-text>

            <v-dialog
              v-model="isShowSelectUploadFileDialog"
              persistent
              max-width="500px"
            >
              <v-btn slot="activator" color="primary" dark>ファイル追加</v-btn>
              <v-card>
                <v-card-title>
                  <span class="headline">追加するファイルの選択</span>
                </v-card-title>
                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-select
                          v-model="selectedUploadFileType"
                          :items="uploadFileTypes"
                          item-text="text"
                          item-value="value"
                          label="ファイル種別"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12>
                        <input
                          type="file"
                          @change.prevent="selectUploadFile"
                          :multiple="true"
                        />
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="blue darken-1"
                    flat
                    @click="isShowSelectUploadFileDialog = false"
                    >Close</v-btn
                  >
                  <v-btn color="primary" @click="uploadFile" :disabled="isBusy"
                    >Save</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-list>
              <v-list-tile
                v-for="uploadFile in uploadFiles"
                :key="uploadFile.id"
              >
                <v-list-tile-content>
                  <v-list-tile-sub-title
                    v-text="uploadFile.type"
                  ></v-list-tile-sub-title>
                  <v-list-tile-title
                    v-text="uploadFile.filename"
                  ></v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>

            <v-layout justify-center>
              <v-btn color="primary" @click="toPublish"
                >作品情報入力画面へ</v-btn
              >
            </v-layout>
          </v-card>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </v-container>
</template>
<script>
import "vue-cropperjs";

export default {
  name: "vc-share-sample-ice-uploader",
  props: {
    csrfToken: {
      type: String,
      default: ""
    },
    jwt: {
      type: String,
      default: ""
    },
    clipAuthToken: {
      thie: String,
      default: ""
    }
  },
  data() {
    return {
      isBusy: false,
      step: 0,
      outputImageTypes: [
        { value: "none", text: "出力しない" },
        { value: "tiff", text: "TIFF形式で出力" }
      ],
      selectedOutputImageType: null,
      title: null,
      draftId: null,
      uploadFiles: [],
      isShowSelectUploadFileDialog: false,
      uploadFileTypes: [
        { value: "thumbnail", text: "サムネイル画像" },
        { value: "bs", text: "BSファイル" },
        { value: "printing_data", text: "印刷用データ" },
        { value: "contents_info", text: "作品情報ファイル（JSON）" },
        { value: "extra_file", text: "作品情報に記載されたファイル" }
      ],
      selectedUploadFileType: null,
      selectedUploadFiles: []
    };
  },
  computed: {},
  methods: {
    draft: function() {
      fetch("/ice-api/v1/upload-contents/draft", {
        body: JSON.stringify({
          output_image_type: this.selectedOutputImageType,
          title: this.title
        }),
        headers: {
          "content-type": "application/json",
          "X-CLIP-AUTH-TOKEN": this.clipAuthToken
        },
        method: "POST"
      })
        .then(response => response.json())
        .then(response => {
          this.draftId = response.draftId;
          this.step = 2;
        });
    },
    selectUploadFile: function(e) {
      var files = e.target.files;
      if (files.length > 0) {
        this.selectedUploadFiles = files;
      }
    },
    uploadFile() {
      if (!this.selectedUploadFileType) {
        return;
      }
      if (this.selectedUploadFiles.length === 0) {
        return;
      }

      this.isBusy = true;

      const promises = [];
      for (let i = 0; i < this.selectedUploadFiles.length; i++) {
        const selectedUploadFile = this.selectedUploadFiles[i];

        promises.push(
          fetch("/ice-api/v1/upload-contents/files", {
            body: JSON.stringify({
              draftId: this.draftId,
              type: this.selectedUploadFileType,
              filename: selectedUploadFile.name
            }),
            headers: {
              "content-type": "application/json",
              "X-CLIP-AUTH-TOKEN": this.clipAuthToken
            },
            method: "POST"
          })
            .then(response => response.json())
            .then(e => {
              return fetch(e.url, {
                body: selectedUploadFile,
                method: "PUT"
              });
            })
            .then(() => {
              this.uploadFiles.push({
                type: this.selectedUploadFileType,
                filename: selectedUploadFile.name
              });
            })
        );
      }
      Promise.all(promises).then(() => {
        this.isBusy = false;
        this.isShowSelectUploadFileDialog = false;
      });
    },
    toPublish: function() {
      let url =
        "/ja-jp/ice-upload-contents?draftId=" +
        this.draftId +
        "&jwt=" +
        this.jwt;
      location.href = url;
    }
  }
};
</script>
